// extracted by mini-css-extract-plugin
export default {"rightBanner":"RightBanner_rightBanner__-Rk-5","bannerImg":"RightBanner_bannerImg__EgsJy","gradientBox":"RightBanner_gradientBox__y42nb"};